export default "__VITE_ASSET__7inGEYQM__"